import React from 'react';
import Accordion from '../../shared-components/accordion/accordion';

export const CateringFaqSection = ({ FAQs = [] }) => {
  return (
    <section className="bg-gray-100 ps-container-lg-margin ps-container-fixed catering-faq-section">
      <div className="ps-row">
        <div className="col-xs-12">
          <h3 className="margin-xl-bottom no-margin">
            Frequently asked questions
          </h3>
          {FAQs.map((faq) => (
            <Accordion
              key={faq.question}
              header={
                <div className="padding-lg-top padding-lg-bottom">
                  {faq.question}
                </div>
              }
            >
              <div className="padding-xl-bottom">{faq.answer}</div>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
};
